import styled from '@emotion/styled';

const Item = styled.li`
  color: #ffffff;
  animation-delay: .35s;
  display: block;
  margin-bottom: 1em;
  min-height: 50px;
  position: relative;
  cursor: pointer;
  max-width: 80vw;
  font-family: 'Karla',serif;
  font-weight: bold;
   
  &:hover {
    color: #00FFFF;
  }
`;

export default Item;
